import { executeSuiTransaction } from '../..'
import type { Swapper } from '../../types'

export const cetusSwapper: Swapper = {
  executeSuiTransaction,
}
